module.exports = __webpack_public_path__ + "img/payment_visa.b6573e89.svg";